/** O prazo chega em horário do servidor. Congela o fim no relógio daqui, senão o número não anda. */
export function prazoNoCliente(fimServidor: number, agoraServidor: number): number {
  if (fimServidor <= 0 || agoraServidor <= 0) return 0;
  return fimServidor - agoraServidor + Date.now();
}

export function relogio(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, '0')}`;
}

export function pctVida(n: number): number {
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, Math.round(n)));
}
